// @flow

// Exports
export default function asJson (value: mixed): Object {
  if (value == null || (typeof value !== 'object' && typeof value !== 'string')) {
    return {}
  } else if (Array.isArray(value)) {
    return value.reduce(function (acc: Object, v: mixed, i: number): Object {
      acc[i] = v
      return acc
    }, {})
  } else if (typeof value === 'string') {
    try {
      return JSON.parse(value) || {}
    } catch (e) {
      return {}
    }
  }
  return value
}
